module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/p2LSrh/tc-custom/9781452121819.jpg?1726519075142",
      "alt": "This image is the cover for the book Gluten-Free Baking for the Holidays"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gluten-Free Baking for the Holidays\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Recipes for everything from spritz cookies to bûche de Noël . . . shatters the assumption that if you can’t eat wheat, you can’t eat well during the holidays.” —"), _c('i', [_vm._v("San Jose Mercury News")])]), _c('br'), _c('br'), _vm._v("The holidays are a time to celebrate and indulge in baked goods warm from the oven. Unfortunately for the gluten-sensitive, seasonal pleasures such as sugar cookies and mincemeat tarts have been off-limits. Not anymore! "), _c('br'), _c('br'), _vm._v("Jeanne Sauvage, author of the popular blog Art of Gluten-Free Baking, has perfected 60 gluten-free recipes with all the flavors of their wheat-filled counterparts. Also included are tips on how wheat-free ingredients work and Jeanne’s own gluten-free flour mix. With favorites like apple pie, plum pudding, rugelach, bûche de Noël—even a gingerbread house—everyone can pull up a chair to the holiday table with comfort and joy."), _c('br'), _c('br'), _vm._v("“Her cookies and cakes and other treats (and I have reached for many a second helping at various Seattle events over the years) are reliably the best on the table even when they’re up against traditional gluten-full baked goods.” —"), _c('i', [_vm._v("Seattle Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeanne Sauvage, Clare Barboza\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0